import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import { PromotionsManager } from "@/components/admin/promotions-manager";
import { apiGet } from "@/services/api";
import type { Promotion } from "@/types";

/** `app/admin/promotions/page.tsx`. */
export function AdminPromotionsPage() {
  const [promotions, setPromotions] = useState<Promotion[]>([]);

  useEffect(() => {
    let active = true;
    void apiGet<{ promotions: Promotion[] }>("/api/admin/promotions").then((data) => {
      if (active) setPromotions(data?.promotions ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminShell title="Promotions & Hero Banners">
      <PromotionsManager initialPromotions={promotions} />
    </AdminShell>
  );
}
